const config = {
  baseCoreAPI: process.env.REACT_APP_BASE_CORE_API,
  baseOnboardingAPI: process.env.REACT_APP_BASE_ONBOARDING_API,
  baseUrl: process.env.REACT_APP_BASE_URL || 'https://web-v2-onboarding.staging-k8s.jubelio.com',
  V2_URL: process.env.V2_URL || 'https://v2.jubelio.com',
  GMAPS_API_KEY: process.env.REACT_APP_GMAPS_API_KEY,
  EXIM_API_URL: process.env.REACT_APP_IMPEX_API || 'https://impex-api.jubelio.com/'
};

export default config;